import { createSlice } from "@reduxjs/toolkit";
import {  getAdminGroup } from "../../api/dashboard/dashboard";

const initialState = {
  totalAdminGroup:null,
  isLoadadminGroup:false,

};

const dashboardAdmin = createSlice({
  name: "dashboardAdmin",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAdminGroup.pending, (state) => {
        state.isLoadadminGroup = true;
      })
      .addCase(getAdminGroup.fulfilled, (state, action) => {
        state.totalAdminGroup = action?.payload;
        state.isLoadadminGroup = false;
      })
      .addCase(getAdminGroup.rejected, (state, action) => {
        state.isLoadadminGroup = false;
        state.error = action?.error;
      })
  },
});

export const {} = dashboardAdmin.actions;

export default dashboardAdmin.reducer;
